import React from 'react'
import './Loader2.css';

const Loader2 = () => {
    return (
        <>
            <div class="loader2 mx-auto"></div>
        </>
    )
}

export default Loader2
